/* @jsx h */
import { defineComponent, h, Ref } from "vue";
import { JSX } from "vue/jsx-runtime";

interface AccordionItem {
  id: string;
  title: string;
  icon?: string;
  badge?: number | null;
  render: () => JSX.Element;
  renderButtons?: () => JSX.Element;
}

export const LemmonAccordion = defineComponent<{
  items: AccordionItem[];
  value: Ref<string>;
}>({
  name: "LemmonAccordion",
  props: ["items", "value"],
  setup(props) {
    const activeSection = props.value;

    const toggleSection = (id: string) => {
      activeSection.value = activeSection.value === id ? id : id;
    };

    return () => (
      <div class="lemmon-accordion flex flex-col flex-1 overflow-hidden">
        {props.items.map((item) => {
          const isExpanded = activeSection.value === item.id;
          return (
            <div
              key={item.id}
              class={`flex flex-col overflow-hidden ${
                isExpanded ? "flex-1" : ""
              }`}
            >
              <div
                class="h-[55px] bg-base-200/50 border-b accordion-header flex items-center p-2 cursor-pointer"
                onClick={() => toggleSection(item.id)}
              >
                <a
                  href="#"
                  data-state={isExpanded}
                  onClick={(e) => e.preventDefault()}
                  class="flex flex-1 select-none text-gray-400 hover:text-accent/50 active:text-accent data-[state=true]:text-accent"
                >
                  <span class="material-symbols-outlined">
                    {isExpanded ? "keyboard_arrow_down" : "chevron_right"}
                  </span>
                  {item.icon && (
                    <span class="material-symbols-outlined mr-2">
                      {item.icon}
                    </span>
                  )}
                  <span class="flex-1">{item.title}</span>
                </a>
                {item.renderButtons && (
                  <div class="flex justify-end items-center">
                    {item.renderButtons()}
                  </div>
                )}
              </div>

              <div
                class={[
                  "accordion-content overflow-hidden transition-[max-height] duration-300",
                  isExpanded
                    ? "flex-1 flex flex-col max-h-[9999px]"
                    : "max-h-0",
                ]}
              >
                {isExpanded ? item.render() : null}
              </div>
            </div>
          );
        })}
      </div>
    );
  },
});
